export default __webpack_public_path__ + "media/images/users/user-mark-johnson-270x320-d5c60135954d6821f6a3a4a1553b5307.jpg";